import { Dialog as MuiDialog } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';

export const PlayerEditorModalStyled = withStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2)
  }
}))(MuiDialog);
